import { MenuItem } from "./menu-item";

export var MENUITEMS: Array<MenuItem> = [
	new MenuItem("Summary Experience", "#summary-experience", "fa fa-user"),
	new MenuItem("Education", "#education", "fa fa-book"),
	new MenuItem("Work", "#work", "fa fa-briefcase"),
	new MenuItem("Skills", "#skills", "fa fa-code"),
	new MenuItem("Contact", "#contact", "fa fa-envelope"),
];
